import ManageComment from "../components/user/ManageComment";

function CommentManager() {
  return (
    <div className="page p-1">
      <ManageComment />
    </div>
  );
}

export default CommentManager;
